import { render, staticRenderFns } from "./FormsList.vue?vue&type=template&id=0bc62136&scoped=true&"
import script from "./FormsList.vue?vue&type=script&lang=js&"
export * from "./FormsList.vue?vue&type=script&lang=js&"
import style0 from "./FormsList.vue?vue&type=style&index=0&id=0bc62136&prod&lang=scss&"
import style1 from "./FormsList.vue?vue&type=style&index=1&id=0bc62136&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc62136",
  null
  
)

export default component.exports